module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/reportcategory/reportcategory-detail/reportcategory-detail.component.css
// module id = ./src/app/admin/lookup-management/reportcategory/reportcategory-detail/reportcategory-detail.component.css
// module chunks = main